import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { AsyncStatus } from '../../constants/async-status';
import IAppConfigs, { IAppConfigValues } from './app-config-interface';
import { getAppConfigs } from './app-config-thunk';

const initialState = {
    appConfigsAsyncStatus: AsyncStatus.INITIAL,
    appConfigs: {},
} as IAppConfigs;
const appConfigSlice = createSlice({
    name: 'appConfig',
    initialState,
    reducers: {},
    extraReducers(builder: any) {
        builder
            // fetch App-Config Values
            .addCase(getAppConfigs.pending, (state: IAppConfigs) => {
                state.appConfigsAsyncStatus = AsyncStatus.LOADING;
            })
            .addCase(
                getAppConfigs.fulfilled,
                (
                    state: IAppConfigs,
                    { payload }: PayloadAction<IAppConfigValues>
                ) => {
                    state.appConfigsAsyncStatus = AsyncStatus.SUCCESS;
                    state.appConfigs = payload;
                }
            )
            .addCase(getAppConfigs.rejected, (state: IAppConfigs) => {
                state.appConfigsAsyncStatus = AsyncStatus.FAILURE;
            });
    },
});

export default appConfigSlice.reducer;
